module.exports = __webpack_public_path__ + "img/Stock-Market-Check-Forecast.7bf639c7.png";